/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ApolloError, useMutation, useQuery } from '@apollo/client'
import { getQueryFor } from '../queries/queryMappints'
import { Box, Button, Heading, HStack, useToast, UseToastOptions } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { MultiElements } from '../components/multiElements'
import {
  keyValue,
  keyValueObject,
  selectIDInterface,
  selectInput,
  SystemComponentProductsinterface,
  systemDocumentInterface,
  systemServicesInterface
} from '../lib/types'
import { GET_ELEMENTS, GET_PRODUCTS, GET_REPORTS, GET_SERVICES, GET_FIXING_TESTED, GET_COMPONENT_PRODUCTS } from '../queries/queries'
import { isArray } from '@apollo/client/cache/inmemory/helpers'
import {
  AddComponentButton,
  ExistingAndNewService,
  fileResult,
  filterObject,
  formDataTemplate,
  getSelectedValue,
  keysToRemove,
  keyValueObjectToSelectOptionsArray,
  MinMaxComponent,
  SelectOptionsInterface,
  Seperator,
  SnapRadio,
  SnapSelectBox,
  SnapText,
  stringToBoolean,
  SystemFormHeading,
  toastOptions
} from './systemForm.support'
import { fileInterface, MultiFileUpload } from '../components/MultiFileUpload/multiFileUpload.main'
import { formatDocTypeToFileUpload, SegmentBox } from '../components/MultiFileUpload/multiFileUpload.support'
import { SystemNotes, systemNotesInterface } from './SystemNotes'

const SystemFormComponent = ({
  formData,
  allTypes,
  mode,
  callBack
}: {
  formData: keyValueObject
  allTypes: keyValueObject
  callBack: () => void
  mode?: 'create' | 'edit'
}): JSX.Element => {
  const filteredIndustryCategory = filterObject(
    allTypes?.industryCategories as keyValue[],
    'industry_category',
    (formData?.industry_category as keyValue)?.industry_category as string
  )
  const initialFromDataProcess = (formDataInput: keyValueObject): keyValueObject => {
    return {
      ...formData,
      application: keysToRemove(formDataInput.application as keyValue, ['__typename']) ?? '',

      industry_category: filteredIndustryCategory && filteredIndustryCategory.length > 0 ? { id: filteredIndustryCategory[0].id as string } : '',
      service_configuration: keysToRemove(formDataInput.service_configuration as keyValue, ['__typename']) ?? {},
      system_component_products: (formData?.system_component_products as keyValueObject[])?.map(item => ({
        ...(keysToRemove(item as keyValue, ['__typename']) ?? (item ? { ...item } : {})),
        component_product: keysToRemove(item.component_product as keyValue, ['__typename'])
      })),
      system_notes: (formData.system_notes as keyValueObject[])?.map(item => keysToRemove(item as keyValue, ['__typename', 'id'])),

      system_products: (formData.system_products as keyValueObject[])?.map(item => ({
        ...item,
        product: keysToRemove(item.product as keyValue, ['__typename'])
      })),

      system_reports: (formData.system_reports as keyValueObject[])?.map(item => ({
        ...item,
        report: keysToRemove(item.report as keyValue, ['__typename'])
      })),
      system_elements: (formData.system_elements as keyValueObject[])?.map(item => ({
        ...item,
        element: keysToRemove(item.element as keyValue, ['__typename'])
      })),
      system_services: (formData.system_services as keyValueObject[])?.map(item => ({
        ...(keysToRemove(item as keyValue, ['__typename']) ?? (item ? { ...item } : {})),
        service: keysToRemove(item.service as keyValue, ['__typename'])
      }))
    }
  }
  const getDefaultReportPrimaryId = (): string => {
    const filteredReports = (formSubmitData?.system_reports as keyValue[])?.filter(item => {
      return item.is_primary
    })

    const result = filteredReports?.length
      ? filteredReports[0]?.report !== null
        ? ((filteredReports[0]?.report as unknown as keyValue).id as string)
        : undefined
      : undefined

    return result as string
  }
  const getDefaultSystemElementsPrimaryId = (): string => {
    const filteredData = (formSubmitData?.system_elements as keyValue[])?.filter(item => {
      return item.is_primary
    })

    const result = filteredData?.length
      ? filteredData[0]?.element !== null
        ? ((filteredData[0]?.element as unknown as keyValue).id as string)
        : undefined
      : undefined

    return result as string
  }
  // This method removes all id and __ typename so that the formData can be sent to the updateQuery
  const prepareFormDataForEditAndCreate = (data: keyValueObject | undefined): keyValueObject | null => {
    const removeTypeNameFromObectAndArrays = (inputData: keyValueObject): keyValueObject | string | null => {
      switch (typeof inputData) {
        case 'object': {
          if (isArray(inputData)) {
            const result = inputData.map((mapItem: keyValue) => {
              const removed = keysToRemove(mapItem, ['__typename']) as keyValue
              const innerValuesUpdated = Object.keys(removed).reduce((innerReducer: keyValueObject, innerItem) => {
                if (innerItem !== '__typename') {
                  const innerRemoved =
                    typeof removed[innerItem] === 'object'
                      ? (keysToRemove(removed[innerItem] as unknown as keyValue, ['__typename']) as unknown as keyValue)
                      : (removed[innerItem] as unknown as keyValue)

                  return {
                    ...innerReducer,
                    [innerItem]: innerRemoved
                  }
                }
                return { innerReducer }
              }, {})
              return innerValuesUpdated
            })

            return result as unknown as keyValueObject
          }

          return keysToRemove(inputData as keyValue, ['__typename']) as unknown as keyValueObject
        }

        default:
          return inputData
      }
    }
    const typeNameRemovedValue = (): keyValueObject | null => {
      if (data) {
        return Object.keys(data ?? []).reduce((reducer: keyValueObject, item) => {
          if (item !== '__typename') {
            return {
              ...reducer,
              [item]: removeTypeNameFromObectAndArrays(data[item] as keyValueObject) as unknown as keyValueObject
            }
          }

          return reducer
        }, {})
      }
      return null
    }
    const result = typeNameRemovedValue()
    return result
  }
  const processSubmitData = (data: keyValueObject | undefined): keyValueObject | boolean => {
    const getID = (): keyValue | object => (mode === 'create' ? {} : { id: formData.id })
    const selectedItem = (
      allTypesUnits: Array<{
        id: string
        unit_name: string
      }>,
      selectedValue: string
    ): Array<{
      id: string
      unit_name: string
    }> =>
      allTypesUnits.filter(item => {
        if (item.unit_name === selectedValue) {
          return true
        }
        return false
      })

    const penetrationDepthUnitItem = selectedItem(
      allTypes.units as Array<{
        id: string
        unit_name: string
      }>,
      data?.penetration_depth_unit as string
    )
    const preparedData = prepareFormDataForEditAndCreate(data) as keyValueObject

    if ((preparedData?.system_elements as keyValue[]).length === 0) {
      toast({
        ...(toastOptions.failureOptions('Please send atleast one Element !') as UseToastOptions)
      })
      return false
    }
    if ((preparedData?.system_products as keyValue[]).length === 0) {
      toast({
        ...(toastOptions.failureOptions('Please send atleast one Product !') as UseToastOptions)
      })
      return false
    }
    if ((preparedData?.system_reports as keyValue[]).length === 0) {
      toast({
        ...(toastOptions.failureOptions('Please send atleast one Report !') as UseToastOptions)
      })
      return false
    }
    if ((preparedData?.system_services as keyValue[]).length === 0) {
      toast({
        ...(toastOptions.failureOptions('Please send atleast one Service !') as UseToastOptions)
      })
      return false
    }
    return {
      ...keysToRemove(
        (prepareFormDataForEditAndCreate(data) as keyValue) ?? {},
        mode === 'edit' ? ['__typename', 'inserted_on', 'modified_on'] : ['__typename', 'id', 'inserted_on', 'modified_on']
      ),
      ...getID(),

      fitting: stringToBoolean((preparedData?.fitting as string)?.toString()) ?? null,
      fitting_allowed: ((preparedData?.fitting_allowed as string) || null) as string,
      display_record: stringToBoolean((preparedData?.display_record as string)?.toString() ?? null),
      priority_order: (preparedData?.priority_order as number) ?? null,
      no_of_services: (preparedData?.no_of_services as string) ?? null,
      multiple_services: (preparedData?.multiple_services as Boolean) ?? false,
      is_active: stringToBoolean((preparedData?.is_active as string)?.toString()) ?? null,
      penetration_depth_unit: penetrationDepthUnitItem?.length > 0 ? penetrationDepthUnitItem[0].unit_name : '',
      system_services:
        (preparedData?.system_services as keyValue[])?.map(object =>
          keysToRemove(
            object ?? {},
            mode === 'create' ? ['__typename', 'id', 'inserted_on', 'modified_on'] : ['__typename', 'inserted_on', 'modified_on']
          )
        ) ?? null,

      application: preparedData?.application === '' ? {} : preparedData?.application ?? {},
      industry_category: preparedData?.industry_category === '' ? {} : (preparedData?.industry_category as keyValue),
      fitting_type: preparedData?.fitting_type === '' ? {} : (keysToRemove(preparedData?.fitting_type as keyValue, ['__typename']) as keyValue)
    }
  }

  const [formSubmitData, setFormSubmitData] = useState<keyValueObject | undefined>()
  const [initialData, setInitialData] = useState<keyValueObject>()
  const toast = useToast()
  const queries = getQueryFor('System')
  const [mutateFunction] = queries
    ? // eslint-disable-next-line react-hooks/rules-of-hooks
      useMutation(mode === 'create' ? queries.create : queries.update, {
        variables: { ...formSubmitData },
        refetchQueries: [{ query: queries.refetch }],
        onCompleted: () => {
          callBack()
          toast({ ...(toastOptions.successOptions as UseToastOptions) })
        },
        onError: (error: ApolloError) => {
          toast({
            ...(toastOptions.failureOptions(error.message) as UseToastOptions)
          })
        }
      })
    : []
  const performSystemSubmit = (): void => {
    const processedSubmitData = processSubmitData(formSubmitData ?? {})
    if (typeof processedSubmitData === 'object' && mutateFunction && queries) {
      mutateFunction({
        variables: {
          input: { ...processedSubmitData }
        }
      })
        .then(res => {})
        .catch(err => {})
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data: allElements, loading: allElementsLoading } = useQuery(GET_ELEMENTS)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data: allProducts, loading: allProductsLoading } = useQuery(GET_PRODUCTS)
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data: allReports, loading: allReportsLoading } = useQuery(GET_REPORTS)
  const { data: allComponentProducts, loading: allComponentProductsLoading } = useQuery(GET_COMPONENT_PRODUCTS)

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { data: allServices, loading: allServicesLoading } = useQuery(GET_SERVICES)

  const { data: allFixingTested, loading: allFixingTestedLoading } = useQuery(GET_FIXING_TESTED)

  const updatedSystemServicesAtIndex = ({
    data,
    index
  }: {
    data: systemServicesInterface | keyValue
    index: number
  }): Array<systemServicesInterface | keyValue> => {
    const formSystemServices = formSubmitData?.system_services as systemServicesInterface[]
    const reducedArray = formSystemServices?.reduce((reducer: Array<systemServicesInterface | keyValue>, item, reducerIndex) => {
      if (reducerIndex === index) {
        return [...reducer, { ...item, ...data }]
      }

      return [...reducer, { ...item }]
    }, [])
    return reducedArray
  }
  const updatedSystemComponentProductsAtIndex = ({
    data,
    index
  }: {
    data: SystemComponentProductsinterface | keyValue
    index: number
  }): Array<SystemComponentProductsinterface | keyValue> => {
    const formSystemServices = formSubmitData?.system_component_products as SystemComponentProductsinterface[]
    const reducedArray = formSystemServices?.reduce((reducer: Array<SystemComponentProductsinterface | keyValue>, item, reducerIndex) => {
      if (reducerIndex === index) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return [...reducer, { ...data }]
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
      return [...reducer, { ...item }]
    }, [])
    return reducedArray
  }

  useEffect(() => {
    setInitialData(mode === 'create' ? formDataTemplate : initialFromDataProcess(formData))
  }, [])

  useEffect(() => {
    setFormSubmitData(initialData)
  }, [initialData])

  return (
    <>
      {!allElementsLoading && !allProductsLoading && !allReportsLoading && !allServicesLoading && formSubmitData && allServices !== undefined && (
        <>
          <HStack mb="4" align="flex-end">
            <SnapText
              title="Priority Order"
              callBack={value => {
                setFormSubmitData(rest => ({ ...rest, priority_order: Number(value) ?? null }))
              }}
              defaultValue={formSubmitData?.priority_order?.toString()}
              type="number"
            />
            <SnapText
              title="System Code"
              defaultValue={formSubmitData?.system_code as string}
              callBack={callBackValue => {
                setFormSubmitData({
                  ...formSubmitData,
                  system_code: callBackValue
                })
              }}
            />
            <SnapText
              title="System Description"
              defaultValue={formSubmitData?.system_description as string}
              callBack={callBackValue => {
                setFormSubmitData({
                  ...formSubmitData,
                  system_description: callBackValue
                })
              }}
            />
          </HStack>
          <HStack mb="4">
            {[
              {
                title: 'Application',
                key: 'application',
                allTypesKey: 'applications',
                allTypesKeyWithValue: 'application_name'
              }
            ].map((item, index) => (
              <Box key={`${item.key}_${index}`} width="100%">
                {formSubmitData !== undefined && (
                  <SnapSelectBox
                    title={item.title}
                    defaultValue={(formSubmitData[item.key] as selectIDInterface)?.id ?? null}
                    options={keyValueObjectToSelectOptionsArray(allTypes[item.allTypesKey] as keyValue[], item.allTypesKeyWithValue)}
                    callBack={selectValue => {
                      setFormSubmitData(rest => ({
                        ...rest,
                        [item.key]: getSelectedValue(selectValue)
                      }))
                    }}
                  />
                )}
              </Box>
            ))}
            {/* Fixing Tested */}
            <SnapSelectBox
              title={'Fixing Tested'}
              defaultValue={((formSubmitData?.fixing_tested as keyValue)?.id as string) ?? ''}
              options={keyValueObjectToSelectOptionsArray(allFixingTested?.fixingTested as keyValue[], 'fixing_test_list')}
              callBack={selectValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  fixing_tested: getSelectedValue(selectValue)
                }))
              }}
            />
          </HStack>

          <HStack mb="4">
            {[
              {
                title: 'Industry Category',
                key: 'industry_category',
                allTypesKey: 'industryCategories',
                allTypesKeyWithValue: 'industry_category'
              },
              {
                title: 'Service Configuration',
                key: 'service_configuration',
                allTypesKey: 'serviceConfigurations',
                allTypesKeyWithValue: 'service_config_name'
              }
            ].map((item, index) => (
              <Box key={`${item.key}_${index}`} width="100%">
                {formSubmitData !== undefined && (
                  <SnapSelectBox
                    title={item.title}
                    defaultValue={(formSubmitData[item.key] as selectIDInterface)?.id ?? null}
                    options={keyValueObjectToSelectOptionsArray(allTypes[item.allTypesKey] as keyValue[], item.allTypesKeyWithValue)}
                    callBack={selectValue => {
                      setFormSubmitData(rest => ({
                        ...rest,
                        [item.key]: getSelectedValue(selectValue)
                      }))
                    }}
                  />
                )}
              </Box>
            ))}
          </HStack>
          <HStack mb="4">
            <SnapRadio
              title="Fitting"
              defaultValue={(formSubmitData?.fitting as string)?.toString()}
              options={[
                { value: 'true', displayValue: 'Y' },
                { value: 'false', displayValue: 'N' }
              ]}
              callBack={radioValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  fitting: radioValue.value === 'true'
                }))
              }}
            />
            <SnapSelectBox
              title="Fitting Allowed"
              options={[
                { value: 'Yes', displayValue: 'Yes' },
                { value: 'No', displayValue: 'No' },
                { value: 'Butt Weld', displayValue: 'Butt Weld' }
              ]}
              defaultValue={(formSubmitData?.fitting_allowed as string) ?? ''}
              callBack={selectValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  fitting_allowed: (selectValue.value || null) as string
                }))
              }}
            />
            <SnapSelectBox
              title="Fitting Type"
              options={keyValueObjectToSelectOptionsArray(allTypes.fittingTypes as keyValue[], 'fitting_type')}
              defaultValue={(formSubmitData?.fitting_type as selectIDInterface)?.id}
              callBack={selectValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  fitting_type: getSelectedValue(selectValue)
                }))
              }}
            />
            <SnapText
              title="Fitness Thickness"
              type="number"
              defaultValue={formSubmitData?.fitting_thickness as string}
              callBack={callBackValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  fitting_thickness: callBackValue
                }))
              }}
            />
          </HStack>
          <Seperator />
          <HStack spacing={4} mt="4">
            <SnapText
              title="Penetration Depth"
              type="number"
              defaultValue={formSubmitData?.penetration_depth as string}
              callBack={callBackValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  penetration_depth: callBackValue
                }))
              }}
            />
            <Box width={'100%'}>
              <SnapSelectBox
                title="Penetration Depth Unit"
                defaultValue={formSubmitData?.penetration_depth_unit as string}
                options={(allTypes.units as keyValue[])?.reduce(
                  (reducer: SelectOptionsInterface[], item) => [
                    ...reducer,
                    {
                      value: item.unit_name as string,
                      displayValue: item.unit_name as string
                    }
                  ],
                  []
                )}
                callBack={selectValue => {
                  setFormSubmitData(rest => ({
                    ...rest,
                    penetration_depth_unit: selectValue.value
                  }))
                }}
              />
            </Box>
          </HStack>
          <HStack mb="4">
            <SnapRadio
              title="Multiple Services"
              defaultValue={(formSubmitData?.multiple_services as string)?.toString()}
              options={[
                { value: 'true', displayValue: 'Y' },
                { value: 'false', displayValue: 'N' }
              ]}
              callBack={radioValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  multiple_services: radioValue.value === 'true'
                }))
              }}
            />
            <SnapText
              title="No. of Services"
              type="number"
              defaultValue={formSubmitData?.no_of_services as string}
              callBack={callBackValue => {
                setFormSubmitData(rest => ({
                  ...rest,
                  no_of_services: callBackValue
                }))
              }}
            />
          </HStack>
          <HStack spacing={4}>
            {[
              { title: 'Is Active', key: 'is_active' },
              { title: 'Display Record', key: 'display_record' }
            ].map((item, index) => (
              <Box key={`${item.key}_${index}`} width="100%">
                <SnapRadio
                  defaultValue={(formSubmitData[item.key] as string)?.toString()}
                  title={item.title}
                  options={[
                    { value: 'true', displayValue: 'Y' },
                    { value: 'false', displayValue: 'N' }
                  ]}
                  callBack={radioValue => {
                    setFormSubmitData(rest => ({
                      ...rest,
                      [item.key]: radioValue.value === 'true'
                    }))
                  }}
                />
              </Box>
            ))}
          </HStack>
          {/* Begining of FRL */}
          <SystemFormHeading title="FRL" />
          <HStack width="100%" flexWrap="wrap" justifyContent="space-evenly">
            {[
              { title: 'FRL Actual ST', key: 'frl_actual_st' },
              { title: 'FRL Actual INT', key: 'frl_actual_int' },
              { title: 'FRL Actual INS', key: 'frl_actual_ins' },
              { title: 'FRL Issued ST', key: 'frl_issued_st' },
              { title: 'FRL Issued INT', key: 'frl_issued_int' },
              { title: 'FRL Issued INS', key: 'frl_issued_ins' }
            ].map((item, index) => (
              <Box key={`${item.key}_${index}`} width="30%">
                {formSubmitData !== undefined && (
                  <SnapText
                    title={item.title}
                    type="number"
                    defaultValue={formSubmitData[item.key] as string}
                    callBack={callBackValue => {
                      setFormSubmitData(rest => ({
                        ...rest,
                        [item.key]: callBackValue ?? ''
                      }))
                    }}
                  />
                )}
              </Box>
            ))}
          </HStack>
          {/* End of FRL */}

          {/* System elements */}
          <Box mt="10">
            <SystemFormHeading title="System Elements" />

            <SegmentBox>
              <MultiElements
                title="Element"
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                optionsArray={allElements.elements as keyValue[]}
                defaultValues={(formSubmitData?.system_elements as keyValueObject[])?.reduce(
                  (reducer: selectInput[], item) => [
                    ...reducer,
                    {
                      value: (item.element as keyValue)?.id as string,
                      label: (item.element as keyValue)?.element_name as string,
                      id: (item.element as keyValue)?.id as string
                    }
                  ],
                  []
                )}
                onChangeCallBack={data => {
                  setFormSubmitData(prev => ({
                    ...prev,
                    system_elements: Object.keys(data.selectedValues).map(item => {
                      const selectedValues = data.selectedValues as keyValueObject

                      const selectedItem = selectedValues[item] as keyValue
                      return {
                        element: {
                          id: selectedItem.id
                        },
                        is_primary: data.selectedPrimary === selectedItem.id
                      }
                    })
                  }))
                }}
                defaultPrimaryId={getDefaultSystemElementsPrimaryId()}
                dataKey={'element_name'}
              />
            </SegmentBox>
          </Box>
          {/* System Products */}
          {Boolean(allProducts) && (
            <>
              <SystemFormHeading title="System Products" />
              <SegmentBox>
                <Box mb="3">
                  <MultiElements
                    title="Products"
                    primarySelector={false}
                    defaultValues={(formSubmitData?.system_products as keyValueObject[])?.reduce(
                      (reducer: selectInput[], item) => [
                        ...reducer,
                        {
                          value: (item.product as keyValue)?.id as string,
                          label: (item.product as keyValue)?.product_code as string,
                          id: (item.product as keyValue)?.id as string
                        }
                      ],
                      []
                    )}
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    optionsArray={allProducts?.products as keyValue[]}
                    onChangeCallBack={data => {
                      setFormSubmitData(prev => ({
                        ...prev,
                        system_products: Object.keys(data.selectedValues)?.map(item => {
                          const selectedValues = data.selectedValues as keyValueObject

                          const selectedItem = selectedValues[item] as keyValue
                          return {
                            product: {
                              id: selectedItem.id
                            }
                          }
                        })
                      }))
                    }}
                    dataKey={'product_code'}
                  />
                </Box>
              </SegmentBox>
            </>
          )}
          {/* System Reports */}
          {Boolean(allReports) && (
            <>
              <SystemFormHeading title="System Reports" />
              <SegmentBox>
                <MultiElements
                  title="Reports"
                  defaultPrimaryId={getDefaultReportPrimaryId()}
                  defaultValues={(formSubmitData?.system_reports as keyValueObject[])?.reduce(
                    (reducer: selectInput[], item) => [
                      ...reducer,
                      {
                        value: (item.report as keyValue)?.id as string,
                        label: (item.report as keyValue)?.report_name as string,
                        id: (item.report as keyValue)?.id as string
                      }
                    ],
                    []
                  )}
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                  optionsArray={(allReports.reports as keyValue[])?.filter(
                    report => (report.is_active as unknown as boolean) !== false
                  )}
                  secondaryField={{
                    label: 'Penetration No.',
                    placeholder: 'e.g. 5',
                    width: '120px'
                  }}
                  defaultSecondaryValues={(formSubmitData?.system_reports as keyValueObject[])?.reduce(
                    (reducer: Record<string, string>, item) => {
                      const reportId = (item.report as keyValue)?.id as string
                      if (reportId) {
                        reducer[reportId] = (item.penetration_no as string) ?? ''
                      }
                      return reducer
                    },
                    {}
                  )}
                  onChangeCallBack={data => {
                    // if (data.selectedPrimary as boolean) {
                    setFormSubmitData(prev => {
                      // Preserve each existing system_report row id (keyed by its linked report id) so
                      // the update mutation edits existing links instead of recreating them, which was
                      // producing a duplicate-id error whenever penetration_no was changed on save.
                      const existingIdByReportId = ((prev?.system_reports as keyValueObject[]) ?? []).reduce(
                        (reducer: Record<string, string>, item) => {
                          const reportId = (item.report as keyValue)?.id as string
                          if (reportId && item.id) {
                            reducer[reportId] = item.id as string
                          }
                          return reducer
                        },
                        {}
                      )

                      return {
                        ...prev,
                        system_reports: Object.keys(data.selectedValues).map(item => {
                          const selectedValues = data.selectedValues as keyValueObject
                          const secondaryValues = (data.secondaryValues as Record<string, string>) ?? {}

                          const selectedItem = selectedValues[item] as keyValue
                          const existingId = existingIdByReportId[selectedItem.id as string]
                          return {
                            ...(existingId ? { id: existingId } : {}),
                            is_primary: data.selectedPrimary === selectedItem.id,
                            penetration_no: secondaryValues[selectedItem.id as string] ?? '',
                            report: {
                              id: selectedItem.id
                            }
                          }
                        })
                      }
                    })
                    // }
                  }}
                  dataKey={'report_name'}
                />
              </SegmentBox>
            </>
          )}
          {/* System Services */}
          <React.Fragment>
            <SystemFormHeading title={'System Services'} />
            <>
              <Heading my="4" mt="5" size={'md'}></Heading>
              {isArray(formSubmitData?.system_services) && (formSubmitData?.system_services as systemServicesInterface[]).length > 0 ? (
                (formSubmitData?.system_services as systemServicesInterface[])?.map((object, index) => {
                  return (
                    <>
                      <SegmentBox
                        closeCallBack={() => {
                          const removedArray = (formSubmitData.system_services as keyValue[]).reduce(
                            (reducer: keyValue[], item: keyValue, arrayIndex) => {
                              if (arrayIndex !== index) {
                                return [...reducer, item] as keyValue[]
                              }
                              return reducer
                            },
                            []
                          )
                          setFormSubmitData(rest => ({
                            ...rest,
                            system_services: [...removedArray]
                          }))
                        }}
                      >
                        <ExistingAndNewService
                          serviceSelectOptions={keyValueObjectToSelectOptionsArray(allServices.services as keyValue[], 'service_name')}
                          defaultServiceValue={(formSubmitData.system_services as systemServicesInterface[])[index].service?.id as string}
                          defaultCategoryServiceValue={
                            (formSubmitData?.system_services as systemServicesInterface[])[index].service_category?.id as string
                          }
                          serviceCategorySelectOptions={keyValueObjectToSelectOptionsArray(allTypes.serviceCategories as keyValue[], 'category_name')}
                          defaultServiceTypeValue={(formSubmitData?.system_services as systemServicesInterface[])[index].service_type?.id as string}
                          serviceTypeSelectOptions={keyValueObjectToSelectOptionsArray(allTypes.serviceTypes as keyValue[], 'service_type')}
                          callBack={data => {
                            const updatedSystemServicesArray = updatedSystemServicesAtIndex({
                              data: data as unknown as keyValue,
                              index
                            })
                            setFormSubmitData(rest => ({
                              ...rest,
                              system_services: [...updatedSystemServicesArray]
                            }))
                          }}
                        />
                        <Seperator
                          chakraProps={{
                            mb: '4',
                            mt: '6',
                            ml: '-4',
                            mr: '-4',
                            bg: 'purple.100'
                          }}
                        />
                        {typeof formSubmitData.system_services === 'object' && (formSubmitData.system_services as keyValue[])?.length > 0 && (
                          <>
                            {(
                              [
                                {
                                  title: 'Is Range',
                                  textBoxKey: 'range_details',
                                  radioKey: 'is_range'
                                }
                                // {
                                //   title: 'Is Lagging',
                                //   textBoxKey: 'lagging_details',
                                //   radioKey: 'is_lagging'
                                // }
                              ] as Array<{
                                title: string
                                textBoxKey: 'range_details' //| 'lagging_details'
                                radioKey: 'is_range' //| 'is_lagging'
                              }>
                            ).map(item => {
                              const currentSystemService = (formSubmitData.system_services as systemServicesInterface[])[index]
                              const currentSystemServiceRadioKey =
                                typeof currentSystemService === 'object' ? currentSystemService[item.radioKey] : null

                              return (
                                <>
                                  <MinMaxComponent
                                    title={item.title}
                                    textBoxKey={item.textBoxKey}
                                    radioKey={item.radioKey}
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
                                    defaultValue={currentSystemServiceRadioKey?.toString() ?? ''}
                                    minTextDefaultValue={
                                      ((formSubmitData?.system_services as systemServicesInterface[])[index]?.[item.textBoxKey]?.min as string) ?? ''
                                    }
                                    maxTextDefaultValue={
                                      ((formSubmitData?.system_services as systemServicesInterface[])[index]?.[item.textBoxKey]?.max as string) ?? ''
                                    }
                                    onChangeCallBack={(callBackValue: unknown) => {
                                      const updatedSystemServicesArray = updatedSystemServicesAtIndex({
                                        data: callBackValue as systemServicesInterface,
                                        index
                                      })

                                      setFormSubmitData(rest => ({
                                        ...rest,
                                        system_services: [...updatedSystemServicesArray]
                                      }))
                                    }}
                                  />
                                  <Seperator
                                    chakraProps={{
                                      mb: '4',
                                      mt: '3',
                                      ml: '-4',
                                      mr: '-4',
                                      bg: 'purple.100'
                                    }}
                                  />
                                </>
                              )
                            })}
                          </>
                        )}
                        <SnapText
                          title="Quantity"
                          defaultValue={(formSubmitData?.system_services as systemServicesInterface[])[index]?.quantity?.toString() ?? ''}
                          callBack={callBackValue => {
                            const currentData = {
                              ...(formSubmitData?.system_services as systemServicesInterface[])[index],
                              ...(formSubmitData.system_services as systemServicesInterface[])[index],
                              quantity: parseInt(callBackValue)
                            }
                            const updatedSystemServicesArray = updatedSystemServicesAtIndex({
                              data: currentData,
                              index
                            })
                            setFormSubmitData(rest => ({
                              ...rest,
                              system_services: [...updatedSystemServicesArray]
                            }))
                          }}
                        />
                      </SegmentBox>
                    </>
                  )
                })
              ) : (
                <></>
              )}
            </>
            <AddComponentButton
              title="Add Service"
              onClickCallBack={() => {
                setFormSubmitData(prev => ({
                  ...prev,
                  system_services: [
                    ...(formSubmitData.system_services as keyValueObject[]),
                    {
                      is_range: false,
                      range_details: null,
                      // is_lagging: false,
                      // lagging_details: null,
                      quantity: null,
                      service: null,
                      service_category: null,
                      service_type: null
                    }
                  ]
                }))
              }}
            />
            {/* Notes */}
            <SystemNotes
              input={formSubmitData?.system_notes ? [...(formSubmitData?.system_notes as systemNotesInterface[])] : []}
              onChangeCallBack={result => {
                setFormSubmitData(rest => ({
                  ...rest,
                  system_notes: [...result]
                }))
              }}
            />
          </React.Fragment>
          {/* System component products */}
          {
            <>
              <SystemFormHeading title="System Component Products" />

              {(formSubmitData?.system_component_products as unknown[])?.map((object, componentIndex) => {
                const systemComponentProducts = formSubmitData?.system_component_products as keyValueObject[]
                const componentProduct = systemComponentProducts[componentIndex].component_product as keyValue | null

                return (
                  <SegmentBox
                    key={`system_component_products${componentIndex}`}
                    closeCallBack={() => {
                      const removedArray = (formSubmitData?.system_component_products as keyValue[]).reduce(
                        (reducer: keyValue[], item: keyValue, arrayIndex) => {
                          if (arrayIndex !== componentIndex) {
                            return [...reducer, item] as keyValue[]
                          }
                          return reducer
                        },
                        []
                      )
                      setFormSubmitData(prev => ({
                        ...prev,
                        system_component_products: removedArray
                      }))
                    }}
                  >
                    <>
                      <SnapSelectBox
                        title="Component Product"
                        defaultValue={componentProduct?.id as string}
                        options={keyValueObjectToSelectOptionsArray(allComponentProducts.componentProducts as keyValue[], 'comp_product_name')}
                        callBack={selectValue => {
                          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                          const currentData = {
                            ...(mode === 'edit' ? (formData?.system_component_products as systemServicesInterface[])[componentIndex] : {}),
                            ...(formSubmitData?.system_component_products as SystemComponentProductsinterface[])[componentIndex],
                            component_product: getSelectedValue(selectValue)
                          }
                          const updatedComponentProductsArray = updatedSystemComponentProductsAtIndex({
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            data: currentData,
                            index: componentIndex
                          })
                          setFormSubmitData(rest => ({
                            ...rest,
                            system_component_products: [
                              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                              ...updatedComponentProductsArray
                            ]
                          }))
                        }}
                      />

                      {Array.isArray(formSubmitData?.system_component_products) && (
                        <>
                          <SnapText
                            title="Component Product Details"
                            defaultValue={
                              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                              (formSubmitData?.system_component_products as SystemComponentProductsinterface[])[componentIndex]
                                .component_product_details
                            }
                            callBack={callBackValue => {
                              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                              const currentData = {
                                ...(mode === 'edit' ? (formData?.system_component_products as systemServicesInterface[])[componentIndex] : {}),
                                ...(formSubmitData?.system_component_products as SystemComponentProductsinterface[])[componentIndex],
                                component_product_details: callBackValue
                              }
                              const updatedComponentProductsArray = updatedSystemComponentProductsAtIndex({
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                data: currentData,
                                index: componentIndex
                              })
                              setFormSubmitData(rest => ({
                                ...rest,
                                system_component_products: [
                                  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                                  ...updatedComponentProductsArray
                                ]
                              }))
                            }}
                          />
                        </>
                      )}
                    </>
                  </SegmentBox>
                )
              })}
              <AddComponentButton
                title="Add Component Product"
                onClickCallBack={() => {
                  setFormSubmitData(prev => ({
                    ...prev,
                    system_component_products: [
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                      ...(formSubmitData?.system_component_products as SystemComponentProductsinterface[]),
                      {
                        component_product: { id: '' },
                        component_product_details: ''
                      }
                    ]
                  }))
                }}
              />
            </>
          }
          {/* FileUpload */}
          <MultiFileUpload
            options={keyValueObjectToSelectOptionsArray(allTypes.documentTypes as keyValue[], 'document_type')}
            defaultData={formatDocTypeToFileUpload(formSubmitData?.system_docs as systemDocumentInterface[])}
            onChangeCallBack={data => {
              const processedResult = data.reduce(
                (reducer: fileResult[], item: fileInterface) => [
                  ...reducer,
                  {
                    id: item.product_doc_id ?? '',
                    document_type: { id: String(item.fileType.id) },
                    document_url: item.file_id ? String(item.file_id) : null,
                    is_private_file: Boolean(item.isPrivateFile)
                  }
                ],
                [] as fileResult[]
              )

              setFormSubmitData(rest => ({
                ...rest,
                system_docs: [...processedResult]
              }))
            }}
          />
          <Box mt="14" display={'flex'} alignItems="center" justifyContent="center">
            <Button height="50px" colorScheme={'red'} bgColor={'primary'} color="white" fontSize={'18px'} width="280px" onClick={performSystemSubmit}>
              Submit
            </Button>
          </Box>
        </>
      )}
    </>
  )
}

export const SystemForm = React.memo(SystemFormComponent)
